<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.6665 8L6.6665 12L13.3332 4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
